import axios from 'axios';
export default {
  async xlsxDownload({ url, params, fileName}) {
    try {
      let res = await axios.get(url, { params });
      return new Promise((resolve, reject) => {
        fetch(res.data)
          .then(t => t.blob())
          .then(b => {
            let attach = document.createElement('a');
            attach.href = URL.createObjectURL(b);
            attach.setAttribute('download', fileName ? fileName : 'language_package');
            attach.click();
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    } catch (error) {
      alert(error);
      throw error;
    }
  },
};
